const { scrollToElement } = require('./helpers/scrollToElement');
const { addQuestionEvents, setAnswer } = require('./sample/sample-question');
const { selectProduct, addSelectProductEvents } = require('./sample/sample-select-product');
const { addSampleFormEvents } = require('./sample/sample-form');
const { preloader } = require('./helpers/preloader');
const { Select } = require('./common/select');
const { analyticsSampleRequest } = require('./analytics/listeners/externallyTriggeredEvents');

/**
 * @class HMSProductSample
 */
window.HMSProductSample = class HMSProductSample {
  static isOnPage() {
    return $('.js-sample-container').length !== 0;
  }
  /**
   * Render a new step
   * @param {String} data - step html received from service
   */
  static renderStep(data) {
    $('.js-sample-container').html(data);
  }

  /**
   * Get current step number from DOM
   * @returns {Number} - Step number
   */
  get step() {
    return Number($('.js-sample').attr('data-stepNumber'));
  }

  /**
   * Check if question is required
   * @returns {Boolean}
   */
  get questionIsRequired() {
    return $('.js-sample-question--is-required').length !== 0;
  }

  get preselectedProduct() {
    const preselectValue = $('.js-sample-container').data('productid');

    return preselectValue && preselectValue.length ? preselectValue : false;
  }

  get preselectedProductName() {
    const preselectValue = $('.js-sample-container').data('productname');

    return preselectValue && preselectValue.length ? preselectValue : false;
  }

  constructor() {
    this.stepsCount = Number($('.js-sample').attr('data-stepCount'));
    this.answer = null;
    this.productSelected = this.preselectedProduct;
    this.productSelectedName = this.preselectedProductName;
    this.productSizeSelected = null;
    this.addStepEvents();
    this.addLoadingEvent();
  }

  /**
   * Inits size dropdowns
   * @param {Node} $sampleContainer
   */
  initSizeDropdowns($sampleContainer) {
    const $size = $sampleContainer.find('.js-form-sample-size');
    if ($size.length) {
      $size.select2(Select.getSelectConfig($size));
      if (this.productSizeSelected) {
        // Here we compare the value selected in the right column to the one selected in the left.
        const selectedOption = document.querySelector(`#AvailableSizesOfSelectedItem-${this.productSelected} option[selected]`);
        let value = this.productSizeSelected;

        if (selectedOption && value !== selectedOption.value) {
          value = selectedOption.value;
        }

        // Now 'value' will have the newest (updated) value and with the line below we update the interface.
        $(`#AvailableSizesOfSelectedItem-${this.productSelected}`)
          .val(value).trigger('change');
      }
    }
  }

  /**
   * Preselects values when navigating back
   */
  preselectValues() {
    if (this.step === 1 && this.productSelected) {
      selectProduct(this);
    }

    if (this.step === 2 && this.stepsCount !== 2 && this.answer) {
      setAnswer(this);
    }
  }

  /**
   * Callback executed when the new step data is loaded.
   * Renders a new step. Adds step events. Init size dropdowns. Preselect values. Scroll into view.
   * If on a last step inits the form events
   * @param {String} data - New step html
   */
  onStepLoaded(data) {
    HMSProductSample.renderStep(data);
    this.addStepEvents();
    const $sampleContainer = $('.js-sample-container');
    if (this.step === this.stepsCount) {
      window.HMS.Form.init();
      if ($('.g-recaptcha').length) {
        new Promise(() => window.grecaptcha.getResponse())
          .catch(() => window.grecaptcha.render($('.g-recaptcha')[0]));
      }
    }
    this.initSizeDropdowns($sampleContainer);
    this.preselectValues();
    preloader($('.js-sample-container'), false);
    scrollToElement($sampleContainer);
  }

  /**
   * Displays error from service response. If service is down shows the generic error.
   * @param {Object} data - service response html
   */
  renderError(data) {
    const $error = $('.js-sample-error');
    if (data) {
      $error.html(data);
    }

    $error.removeClass('hide');
    scrollToElement($error);
    if (this.step === 1) {
      selectProduct(this, true);
    }
    preloader($('.js-sample-container'), false);
  }

  /**
   * When product info is loaded - previous product info is removed, while the new one is added
   * @param {Object} data - section html
   */
  onProductInfoLoaded(data) {
    $('.js-sample-selected-info').remove();
    const $selectedSampleInfo = $('.js-sample-selected-info-container');
    $selectedSampleInfo.prepend(data);
    // Init select
    const $size = $selectedSampleInfo.find('.js-select');
    $size.select2(Select.getSelectConfig($size));
    preloader($('.js-sample-container'), false);
  }

  /**
   * Gets selected product data from the dom.
   * @param {Node} $input - selected product input
   * @returns {Object} - selected product data
   */
  getSelectedProductData($input) {
    const $productContainer = $input.parents('.js-sample-product');
    const sampleSize = [];
    const selectedSize = $productContainer.find('.js-form-sample-size').val();
    // The regex finds <br> or <br/> in the string.
    const regex = /<br\s*\/?>/gi;

    $productContainer.find('.js-form-sample-size option').each((index, size) => {
      if (size.value !== '') {
        sampleSize.push({
          size: size.innerText,
          sizeValue : size.value,
          isSelected: size.value === selectedSize
        });
      }
    });

    return {
      id: this.productSelected,
      assetUrl: $input.attr('data-image-src'),
      description: $.trim($productContainer.find('.js-sample-description').html().replace(regex, '\n')),
      title: $.trim($productContainer.find('.js-sample-title').html().replace(regex, '\n')),
      sampleSize,
      packageCode: $input.data('packagecode'),
      actionCode: $input.data('actioncode')
    };
  }

  /**
   * Get selected product info
   * @param {String} url
   * @param {Node} $input
   */
  getProductInfo(url, $input) {
    preloader($('.js-sample-container'), true);
    $.ajax({
      data: this.getSelectedProductData($input),
      url,
      type: 'POST',
      success: dataResponse => this.onProductInfoLoaded(dataResponse),
      error: jqXHR => this.renderError(jqXHR.responseText)
    });
  }

  /**
   * Step navigation next / previous.
   * Sends step to service
   * @param {Boolean} isPreviousSelected
   */
  onStepNav(isPreviousSelected) {
    const data = {
      currentStep: this.step
    };
    if (isPreviousSelected) {
      data.isPreviousSelected = true;
    }

    if (this.step === 2 && !isPreviousSelected) {
      data.questionAnswer = {
        question: $.trim($('.js-sample-question').html()),
        answer: this.answer
      };
    }
    this.sendStep(data, isPreviousSelected);
  }

  /**
   * Add step event listeners
   */
  addStepEvents() {
    analyticsSampleRequest(`Step ${this.step}`, this.productSelectedName || '');

    // Step 1 - Product selector
    if (this.step === 1) {
      addSelectProductEvents(this);

      return;
    } else if (this.step === this.stepsCount) {
      addSampleFormEvents(this)

      return;
    }

    // Step 2 if not last - Question
    addQuestionEvents(this);
  }

  /**
   * Add sample loading event listener
   */
  addLoadingEvent() {
    if ($('.sample-loading').length > 0) {
      const $loadingTime = parseInt($('.js-sample-loading-container').data('loading-time'), 10);

      $('.header-container').css('display', 'none');
      $('body').addClass('sample-loading-active');

      setTimeout(() => {
        $('body').removeClass('sample-loading-active');
        $('.js-sample-loading-container').css('display', 'none');
        $('.header-container').css('display', 'block');
      }, $loadingTime);
    }
  }

  /**
   * Generates information about the options in an array
   * @returns {Array} Array of sizes
   */
  getProductSizes() {
    const sampleSize = [];
    const $sizeSelect = $('#AvailableSizesOfSelectedItem');
    const selectedSize = $sizeSelect.val();

    $sizeSelect.find('option').each((index, size) => {
      if (size.value !== '') {
        sampleSize.push({
          size: size.innerText,
          sizeValue : size.value,
          isSelected: size.value === selectedSize
        });
      }
    });

    return sampleSize;
  }

  /**
   * The actual sending of data using ajax
   * @param {String} url - Url for sending to BE
   * @param {Object} data - Current step data
   */
  sendStepAjax(url, data) {
    $.ajax({
      url,
      type: 'POST',
      data,
      success: dataResponse => this.onStepLoaded(dataResponse),
      error: jqXHR => this.renderError(jqXHR.responseText)
    });
  }

  /**
   * Send step data to service
   * @param {Object} data - current step data
   * @param {Boolean} isPreviousSelected - true if returning to previous step
   */
  sendStep(data, isPreviousSelected) {
    preloader($('.js-sample-container'), true);
    const url = isPreviousSelected ?
      $('.js-sample-previous').data('url') :
      $('.js-sample-container').find('form').attr('action');

    if (isPreviousSelected) {
      $.ajax({
        data: { sampleSize: this.getProductSizes() },
        url: $('#AvailableSizesOfSelectedItem').data('url'),
        type: 'POST',
        success: () => this.sendStepAjax(url, data),
        error: jqXHR => this.renderError(jqXHR.responseText)
      });
    } else {
      this.sendStepAjax(url, data);
    }
  }
}